import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1069f079"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[40px] tw-self-stretch tw-p-[40px] tw-bg-[#FFFFFF]" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_5 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[25px]" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-justify-between md:tw-items-start tw-gap-[20px] tw-self-stretch tw-rounded-[4px] tw-p-[10px] md:tw-p-[25px] main" }
const _hoisted_7 = { class: "tw-w-full tw-flex md:tw-items-center tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row" }
const _hoisted_8 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px]" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-1 tw-text-[#F7553C]" }, "*", -1))
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative" }
const _hoisted_11 = {
  key: 0,
  class: "invalid-message"
}
const _hoisted_12 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row" }
const _hoisted_13 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px] tw-pt-[21px]" }
const _hoisted_14 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "tw-flex tw-flex-row tw-justify-end tw-items-center tw-w-full" }

import { ref, watch, onMounted, PropType, reactive } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import ButtonLoading from "../common/buttonLoading.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Assessment } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'duplicateAssessmentModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  checklistAssessmentData: {
    type: Object as PropType<IAssessmentDetail>,
    required: true,
  },
  updateDataFucntion: {
    type: Function as PropType<(payload: any) => Promise<void>>,
    required: false,
    default: undefined,
  },
},
  emits: ["update:show", "update:data"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
const name = ref(props.checklistAssessmentData.checklistName);
const description: any = ref(
  props.checklistAssessmentData.checklistDescription,
);
const autoTextarea: any = ref(null);
const isLoading = ref(false);

const initialForm = { name, description };
// Form modal and validation.
const formModel = reactive({ ...initialForm });
const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
};
const $v = useVuelidate(rules, formModel);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "auto"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

onMounted(() => {
  autoResize();
});



const handleCloseModal = async (isClickIcon = false) => {
  if (!isClickIcon && (formModel.name || formModel.description)) return;

  showRef.value = false;
  emit("update:show", showRef.value);
};

const duplicateAssessment = async () => {
  try {
    isLoading.value = true;
    await $v.value.$validate();
    if ($v.value.$invalid) return;

    if (props.updateDataFucntion) {
      await props.updateDataFucntion({
        checklistName: formModel.name,
        checklistDescription: formModel.description,
      });
    } else {
      emit("update:data", {
        checklistName: formModel.name,
        checklistDescription: formModel.description,
      });
    }
    handleCloseModal(true);
  } catch (error: any) {
    showErrorAPI(error, Assessment.getCheckListDuplicate);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]",
    visible: _unref(showRef),
    "border-radius": "4px",
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: _normalizeClass(`modal-header`),
        title: 
        _unref(getComponentUiText)(
          'app-component-assessment-duplicate-assessment-modal-header-title-1',
        )
      ,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (handleCloseModal(true)))
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-duplicate-assessment-modal-title-1",
            )), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-duplicate-assessment-modal-description-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-duplicate-assessment-modal-field-name-1",
                )) + " ", 1),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_BFormInput, {
                  modelValue: formModel.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.name) = $event)),
                  type: "text",
                  placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-duplicate-assessment-modal-field-placeholder-name-1',
                  )
                ,
                  class: _normalizeClass([`tw-border tw-text-[#231F20] tw-text-[15px] tw-h-[66px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF] ${
                  _unref($v)?.$errors?.[0]?.$message
                    ? 'tw-border-[#f7553c] tw-bg-[#fee5e2] focus:!tw-ring-[0.2rem] focus:!tw-ring-[rgba(220,53,69,0.25)] focus:!tw-border-[#f7553c]'
                    : ''
                }`, "autoFocus"]),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref($v).name.$touch()))
                }, null, 8, ["modelValue", "placeholder", "class"]),
                (_unref($v)?.$errors?.[0]?.$message)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref($v)?.$errors?.[0]?.$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-duplicate-assessment-modal-field-description-1",
                )), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  ref_key: "autoTextarea",
                  ref: autoTextarea,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.description) = $event)),
                  placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-duplicate-assessment-modal-field-placeholder-description-1',
                  )
                ,
                  style: `outline-color : #EFF0F1`,
                  class: "auto-expand tw-min-h-[82px] tw-text-[15px] tw-font-normal tw-leading-none tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]",
                  onInput: autoResize
                }, null, 40, _hoisted_15), [
                  [_vModelText, formModel.description]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_b_button, {
            variant: "primary",
            class: "tw-w-fit tw-h-[39px] tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px] tw-border-2 tw-border-solid hover:!tw-border-[#0069d9]",
            type: "submit",
            onClick: handleCloseModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-duplicate-assessment-modal-button-cancel-1",
            )), 1)
            ]),
            _: 1
          }),
          _createVNode(ButtonLoading, {
            title: 
            _unref(getComponentUiText)(
              'app-component-assessment-duplicate-assessment-modal-button-duplicate-1',
            )
          ,
            "is-loading": isLoading.value,
            onClickAction: duplicateAssessment
          }, null, 8, ["title", "is-loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})